import React, { useState } from 'react'
import './Gallery.scss'

import { isMobile } from 'react-device-detect'
import SliderComponent from './SliderComponent/SliderComponent'
import { pictures } from './galleryConfig'

const Galery = () => {
  const [sliderOpen, changeSliderOpen] = useState(false)
  const [idImage, changeIdImage] = useState(1)

  const handleBackdrop = () => {
    changeSliderOpen(false)
  }

  const handleSlider = (id) => {
    changeSliderOpen(true)
    changeIdImage(id)
  }

  let leftImages = []
  let midImages = []
  let rightImages = []

  pictures.forEach((item, index) => {
    let itemToAdd = (
      <div className="gallery__content__item" key={item.name + item.id}>
        <img
          src={item.thumbUrl}
          className="gallery__content__item__image"
          alt={item.name + item.id}
          onClick={() => handleSlider(item.id)}
          onKeyPress={() => handleSlider(item.id)}
          tabIndex="0"
        />
      </div>
    )
    if (isMobile === false) {
      let modulo = (index + 1) % 3

      if (modulo === 0) {
        rightImages.push(itemToAdd)
      } else if (modulo === 1) {
        leftImages.push(itemToAdd)
      } else if (modulo === 2) {
        midImages.push(itemToAdd)
      } else {
        return null
      }
    } else {
      let modulo = (index + 1) % 2
      if (modulo === 0) {
        rightImages.push(itemToAdd)
      } else if (modulo === 1) {
        leftImages.push(itemToAdd)
      } else {
        return null
      }
    }
  })

  let showMiddleColumn = null
  if (!isMobile) {
    showMiddleColumn = <div className="gallery__content__mid">{midImages}</div>
  }

  return (
    <>
      <section className="gallery" id="gallery">
        <h1 className="gallery__title">Galeria</h1>
        <div className="gallery__content">
          <SliderComponent
            isOpen={sliderOpen}
            images={pictures}
            id={idImage}
            onClose={handleBackdrop}
          />
          <div className="gallery__content__left">{leftImages}</div>
          {showMiddleColumn}
          <div className="gallery__content__right">{rightImages}</div>
        </div>
      </section>
    </>
  )
}

export default Galery
